"use strict";
var BoundCallbackObservable_1 = require('./BoundCallbackObservable');
exports.bindCallback = BoundCallbackObservable_1.BoundCallbackObservable.create;
//# sourceMappingURL=bindCallback.js.map


// WEBPACK FOOTER //
// ./techpad-upgrade/~/rxjs/observable/bindCallback.js